import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      gap: rem(24),
    },
    item: {},
    itemImgWrapper: {},
    itemTitle: {},
    dropdownRoot: {
      position: 'relative',
      height: rem(40),
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
    },
    dropdownSelected: {
      position: 'absolute',
      width: '100%',
      paddingRight: rem(12),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    dropdownSelectedWrapper: {
      '.title': {
        fontWeight: 600,
        color: theme.colors.gray[6],
      },
    },
    selectRoot: {
      width: '100%',
    },
    selectDropdown: {
      top: '100%!important',
      borderRadius: 0,
      border: 0,
    },
    selectInput: {
      opacity: 0,
    },
    selectItemsWrapper: {
      padding: rem(4),
    },
    selectItem: {
      padding: `${rem(5)} 0`,
      '&[data-selected="true"]': {
        background: theme.colors.gray[1],
        color: theme.colors.gray[7],
      },
      [theme.fn.smallerThan('sm')]: {
        '& > a': {
          padding: `${rem(5)} ${rem(8)}`,
        },
      },
    },
    selectRightSection: {
      display: 'none',
    },
  }
})
